var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chanceLeftContainer",style:(_vm.styleObj)},[_c('i18n',{attrs:{"path":"lottery_chance_note","tag":"span"}},[_c('span',{staticClass:"chanceHighlight"},[_vm._v(_vm._s(_vm.lotteryTicketCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }